// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__18IJl","icon":"SortAdornment_icon__15HAb","up":"SortAdornment_up__3kiem","down":"SortAdornment_down__3aLb1","active":"SortAdornment_active__2CIYO"};